/**
 * A function to create a log object for the 'openEditor' event (evid: 10)
 *
 * Event description: user/UoU opened the rc editor
 *
 * @param {openEditorParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} container - gorups/blog..
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - gorup_id..
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - []
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} content_id - content_id
 * @return {LogObject<openEditorParams>} LogObject<openEditorParams>
 */
export function openEditor(params) {
    return { evid: 10, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'addPluginStep' event (evid: 11)
 *
 * Event description: Steps between clicking on the plugin and adding it on stage
 *
 * @param {addPluginStepParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events etc
 * @property {string} step - []
 * @property {string} params - more details about the plugin
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<addPluginStepParams>} LogObject<addPluginStepParams>
 */
export function addPluginStep(params) {
    return { evid: 11, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginAttributesChanged' event (evid: 12)
 *
 * Event description: Event triggers for every change in plugin's attribute in Tiptap
 *
 * @param {pluginAttributesChangedParams} params - The parameters for this event
 * @property {string} editor_engine - draft/tiptap
 * @property {string} container - blog/groups/forum etc...
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} attribute - attribute name
 * @property {string} plugin_id - plugin id
 * @property {string} value - action value
 * @property {string} content_id - Content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<pluginAttributesChangedParams>} LogObject<pluginAttributesChangedParams>
 */
export function pluginAttributesChanged(params) {
    return { evid: 12, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'uploadMediaTry' event (evid: 13)
 *
 * Event description: upload media in RCE started (per file) Not from media manager
 *
 * @param {uploadMediaTryParams} params - The parameters for this event
 * @property {string} mediaType - video/image/etc.
 * @property {string} container - []
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - []
 * @property {string} version - rce versoin
 * @property {GUID} rce_session_id - []
 * @property {number} fileSize - []
 * @property {string} correlationId - to connect with success event
 * @property {string} plugin_id - []
 * @property {string} type - not in use
 * @property {string} content_id - content_id
 * @return {LogObject<uploadMediaTryParams>} LogObject<uploadMediaTryParams>
 */
export function uploadMediaTry(params) {
    return { evid: 13, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'uploadMediaFinished' event (evid: 14)
 *
 * Event description: upload media in RCE finished (per file) Not from media manager
 *
 * @param {uploadMediaFinishedParams} params - The parameters for this event
 * @property {number} duration - in ms
 * @property {string} mediaType - video/image/etc.
 * @property {string} container - []
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - []
 * @property {string} errorReason - []
 * @property {boolean} isSuccess - []
 * @property {string} version - rce versoin
 * @property {GUID} rce_session_id - []
 * @property {number} fileSize - []
 * @property {string} correlationId - to connect with success event
 * @property {string} plugin_id - []
 * @property {string} type - not in use
 * @property {string} content_id - content_id
 * @return {LogObject<uploadMediaFinishedParams>} LogObject<uploadMediaFinishedParams>
 */
export function uploadMediaFinished(params) {
    return { evid: 14, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'viewerLoaded' event (evid: 15)
 *
 * Event description: RCV is loaded
 *
 * @param {viewerLoadedParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {boolean} preview - preview=true/full=false
 * @property {string} postURL - post url
 * @property {string} container - consumer name
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp / Editor
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - (on refresh)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} pluginsCount - JSON containing {plugin_id: num of plugins}
 * @property {string} content_id - external content id (based on usage)
 * @return {LogObject<viewerLoadedParams>} LogObject<viewerLoadedParams>
 */
export function viewerLoaded(params) {
    return { evid: 15, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'contentAdded' event (evid: 16)
 *
 * Event description: An event for adding any content
 *
 * @param {contentAddedParams} params - The parameters for this event
 * @property {number} editing_time - in seconds
 * @property {string} post_id - post_id
 * @property {string} editor_engine - draft/tiptap
 * @property {number} paragraph_count - .
 * @property {string} container - consumer name
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} container_type - .
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - (on refresh)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {number} word_count - .
 * @property {string} contact_id - external content id (based on usage)
 * @property {string} content_id - content_id
 * @return {LogObject<contentAddedParams>} LogObject<contentAddedParams>
 */
export function contentAdded(params) {
    return { evid: 16, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'menuLoad' event (evid: 17)
 *
 * Event description: Event for loading a menu (+, more, etc.)
 *
 * @param {menuLoadParams} params - The parameters for this event
 * @property {string} menu - more, + side menu
 * @property {string} post_id - post_id
 * @property {string} container - consumer name
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - (on refresh)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} content_id - external content id (based on usage)
 * @return {LogObject<menuLoadParams>} LogObject<menuLoadParams>
 */
export function menuLoad(params) {
    return { evid: 17, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'addPlugin' event (evid: 2)
 *
 * Event description: user clicked add on a plug in
 *
 * @param {addPluginParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events etc.
 * @property {string} post_id - post id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} button_name - Specify button name
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {string} search_term - in case the user search for the plugin the search term
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} client_id - client_id
 * @return {LogObject<addPluginParams>} LogObject<addPluginParams>
 */
export function addPlugin(params) {
    return { evid: 2, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'tablePluginAddColumnRow' event (evid: 20)
 *
 * Event description: each time column or row add to a table plug in
 *
 * @param {tablePluginAddColumnRowParams} params - The parameters for this event
 * @property {string} source - 3 dot menu/ + sign
 * @property {string} post_id - the post id from the consumer
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} loaction - right/left/above/below
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} category - column/row
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @return {LogObject<tablePluginAddColumnRowParams>} LogObject<tablePluginAddColumnRowParams>
 */
export function tablePluginAddColumnRow(params) {
    return { evid: 20, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'tablePluginDeleteColumnRow' event (evid: 21)
 *
 * Event description: each time column or row delete from a table plugin
 *
 * @param {tablePluginDeleteColumnRowParams} params - The parameters for this event
 * @property {string} post_id - the post id from the consumer
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} category - column/row
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @return {LogObject<tablePluginDeleteColumnRowParams>} LogObject<tablePluginDeleteColumnRowParams>
 */
export function tablePluginDeleteColumnRow(params) {
    return { evid: 21, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'tablePluginClickOnOptionMenu' event (evid: 22)
 *
 * Event description: arrived each time user click on 3 dots menu
 *
 * @param {tablePluginClickOnOptionMenuParams} params - The parameters for this event
 * @property {string} post_id - the post id from the consumer
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} category - table/column/row
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @return {LogObject<tablePluginClickOnOptionMenuParams>} LogObject<tablePluginClickOnOptionMenuParams>
 */
export function tablePluginClickOnOptionMenu(params) {
    return { evid: 22, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'tablePluginClickActionFromOptionMenu' event (evid: 23)
 *
 * Event description: arrived each time user click on an action in 3 dots menu
 *
 * @param {tablePluginClickActionFromOptionMenuParams} params - The parameters for this event
 * @property {string} post_id - the post id from the consumer
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} actionName - clear/merge cells / distribute rows / split cells
 * @property {string} category - table/column/row
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @return {LogObject<tablePluginClickActionFromOptionMenuParams>} LogObject<tablePluginClickActionFromOptionMenuParams>
 */
export function tablePluginClickActionFromOptionMenu(params) {
    return { evid: 23, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'changePluginSettings' event (evid: 25)
 *
 * Event description: each time user change plugin settings
 * the params will arrive according to the plugin
 * link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p
 *
 * @param {changePluginSettingsParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} params - params will arrive according to the plugin
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} actionName - action name
 * @property {string} plugin_id - plugin id
 * @property {string} layout - in case there is then plugin layout
 * @property {string} plugins_details - specification of the plugin
 * @property {string} value - action value
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<changePluginSettingsParams>} LogObject<changePluginSettingsParams>
 */
export function changePluginSettings(params) {
    return { evid: 25, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'addPluginLink' event (evid: 26)
 *
 * Event description: each time user add link to the plugin.
 * the params will arrive according to the plugin
 * link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p
 *
 * @param {addPluginLinkParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} params - params will arrive according to the plugin
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<addPluginLinkParams>} LogObject<addPluginLinkParams>
 */
export function addPluginLink(params) {
    return { evid: 26, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'changePlugin' event (evid: 3)
 *
 * Event description: user changed plugin setting (i.e user clicks button in toolbar that causes a change in plugin - including text)
 *
 * @param {changePluginParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} button_name - the name of the button user clicked on
 * @property {string} container - blog/groups...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version . of rce
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} origin - toolbar/sidebar/ else
 * @property {string} category - category of change (alignment/size/settings...)
 * @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
 * @property {string} plugin_id - plugin
 * @property {string} type - toolbar type (plugin toolbar/ format toolbar)
 * @property {string} plugins_details - specification of the plugin
 * @property {string} value - value changed to (center, right...)
 * @property {string} content_id - content_id
 * @return {LogObject<changePluginParams>} LogObject<changePluginParams>
 */
export function changePlugin(params) {
    return { evid: 3, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginTableColumnRowAction' event (evid: 32)
 *
 * Event description: Each time the user make a change in the look of the table (change column/row order (drag and drop), change column width/ change row height
 *
 * @param {pluginTableColumnRowActionParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} category - row/column
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} action - the action name
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<pluginTableColumnRowActionParams>} LogObject<pluginTableColumnRowActionParams>
 */
export function pluginTableColumnRowAction(params) {
    return { evid: 32, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginModalOpened' event (evid: 33)
 *
 * Event description: after click on plugin icon this event indicate that the modal is opened
 *
 * @param {pluginModalOpenedParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events etc
 * @property {string} post_id - post id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} container - blog/groups/forum etc...
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - inline, side_toolbar, footer_toolbar, shortcut, static_toolbar, floating_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point (popover, floating_toolbar)
 * @property {string} dropdown_value - indicates which value were selected from dropdown menu opening the modal (e.g. Content AI)
 * @property {GUID} modal_session_id - modal_session_id - when the AI modal is opened
 * @return {LogObject<pluginModalOpenedParams>} LogObject<pluginModalOpenedParams>
 */
export function pluginModalOpened(params) {
    return { evid: 33, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'searchInsideThePlugin' event (evid: 34)
 *
 * Event description: when user search inside plugin
 *
 * @param {searchInsideThePluginParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events
 * @property {string} post_id - post id
 * @property {string} searchTerm - the word the user search for
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<searchInsideThePluginParams>} LogObject<searchInsideThePluginParams>
 */
export function searchInsideThePlugin(params) {
    return { evid: 34, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'searchForPlugin' event (evid: 35)
 *
 * Event description: when user search for plugin
 *
 * @param {searchForPluginParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} searchTerm - the word the user search for
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<searchForPluginParams>} LogObject<searchForPluginParams>
 */
export function searchForPlugin(params) {
    return { evid: 35, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'settingsModalOpenedForPlugin' event (evid: 36)
 *
 * Event description: each time the user opened the settings modal for plugin
 *
 * @param {settingsModalOpenedForPluginParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<settingsModalOpenedForPluginParams>} LogObject<settingsModalOpenedForPluginParams>
 */
export function settingsModalOpenedForPlugin(params) {
    return { evid: 36, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'settingsModalClosedForPlugin' event (evid: 37)
 *
 * Event description: each time the user closed the settings modal for plugin
 *
 * @param {settingsModalClosedForPluginParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} outcome - save/close
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
 * @property {string} plugin_id - plugin id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<settingsModalClosedForPluginParams>} LogObject<settingsModalClosedForPluginParams>
 */
export function settingsModalClosedForPlugin(params) {
    return { evid: 37, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'panelNavigateRce' event (evid: 38)
 *
 * Event description: user navigate inside the panel of RCE in the editor
 *
 * @param {panelNavigateRceParams} params - The parameters for this event
 * @property {string} category - main/design/settings/support
 * @property {string} component_id - unique id of the component
 * @property {string} content_id - content_id
 * @return {LogObject<panelNavigateRceParams>} LogObject<panelNavigateRceParams>
 */
export function panelNavigateRce(params) {
    return { evid: 38, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'panelDesignNavigateRce' event (evid: 39)
 *
 * Event description: user navigate inside the Design panel of RCE
 *  in the editor
 *
 * @param {panelDesignNavigateRceParams} params - The parameters for this event
 * @property {string} subcategory - background/texts/button and links
 * @property {string} category - main/design/settings/support
 * @property {string} component_id - unique id of the component
 * @property {string} content_id - content_id
 * @return {LogObject<panelDesignNavigateRceParams>} LogObject<panelDesignNavigateRceParams>
 */
export function panelDesignNavigateRce(params) {
    return { evid: 39, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'deletePlugin' event (evid: 4)
 *
 * Event description: user deleted a plugin
 *
 * @param {deletePluginParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} container - blog/...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugin_id - []
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @return {LogObject<deletePluginParams>} LogObject<deletePluginParams>
 */
export function deletePlugin(params) {
    return { evid: 4, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'clickEditContentRce' event (evid: 40)
 *
 * Event description: user click on edit content inside the panel of RCE
 *  in the editor
 *
 * @param {clickEditContentRceParams} params - The parameters for this event
 * @property {string} origin - rce_panel / gfpp
 * @property {string} component_id - unique id of the component
 * @property {string} content_id - content_id
 * @return {LogObject<clickEditContentRceParams>} LogObject<clickEditContentRceParams>
 */
export function clickEditContentRce(params) {
    return { evid: 40, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'editDesignRce' event (evid: 41)
 *
 * Event description: user edit the design inside the panel of RCE in the editor
 *
 * @param {editDesignRceParams} params - The parameters for this event
 * @property {string} subcategory - the sub category of the change
 * @property {string} category - the main category of the change
 * @property {string} component_id - unique id of the component
 * @property {string} value - the value has change
 * @property {string} content_id - content_id
 * @return {LogObject<editDesignRceParams>} LogObject<editDesignRceParams>
 */
export function editDesignRce(params) {
    return { evid: 41, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'resetToOriginalDesign' event (evid: 42)
 *
 * Event description: user click on reset all design param to the original params
 *  in the editor
 *
 * @param {resetToOriginalDesignParams} params - The parameters for this event
 * @property {string} category - the main category of the change
 * @property {string} component_id - unique id of the component
 * @property {string} content_id - content_id
 * @return {LogObject<resetToOriginalDesignParams>} LogObject<resetToOriginalDesignParams>
 */
export function resetToOriginalDesign(params) {
    return { evid: 42, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'clickExtensionButtonInToolbar' event (evid: 44)
 *
 * Event description: user clicked the extension button in the formatting/plugin toolbar
 *
 * @param {clickExtensionButtonInToolbarParams} params - The parameters for this event
 * @property {string} buttonType - formatting/plugin
 * @property {string} toolbarType - toolbar_type
 * @property {string} toolbar_type - toolbar_type
 * @property {string} button_type - formatting/plugin
 * @property {string} post_id - post id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar,footer_toolbar
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<clickExtensionButtonInToolbarParams>} LogObject<clickExtensionButtonInToolbarParams>
 */
export function clickExtensionButtonInToolbar(params) {
    return { evid: 44, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'inlineToolbarOpened' event (evid: 46)
 *
 * Event description: Inline toolbar opened (when user selects text)
 *
 * @param {inlineToolbarOpenedParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} container - consumer name
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - (on refresh)
 * @property {string} toolbarType - plugin/formatting
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugin_id - plugin from which the toolbar was opened
 * @property {string} content_id - external content id (based on usage)
 * @return {LogObject<inlineToolbarOpenedParams>} LogObject<inlineToolbarOpenedParams>
 */
export function inlineToolbarOpened(params) {
    return { evid: 46, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'keyboardShortcutAction' event (evid: 47)
 *
 * Event description: user changed plugin setting by a keyboard shortcut action
 *
 * @param {keyboardShortcutActionParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} button_name - the name of the button user clicked on
 * @property {string} container - blog/groups...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version . of rce
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} origin - toolbar/sidebar/ else
 * @property {string} category - category of change (alignment/size/settings...)
 * @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
 * @property {string} plugin_id - plugin
 * @property {string} type - toolbar type (plugin toolbar/ format toolbar)
 * @property {string} plugins_details - specification of the plugin
 * @property {string} value - value changed to (center, right...)
 * @property {string} content_id - content_id
 * @return {LogObject<keyboardShortcutActionParams>} LogObject<keyboardShortcutActionParams>
 */
export function keyboardShortcutAction(params) {
    return { evid: 47, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginToolbarLoaded' event (evid: 48)
 *
 * Event description: when a plugin toolbar is loaded in mobile apps
 *
 * @param {pluginToolbarLoadedParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - rce_session_id
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} pluginName - -
 * @property {string} plugin_id - -
 * @property {string} content_id - content_id
 * @return {LogObject<pluginToolbarLoadedParams>} LogObject<pluginToolbarLoadedParams>
 */
export function pluginToolbarLoaded(params) {
    return { evid: 48, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'mobilePluginsActionSheetClick' event (evid: 49)
 *
 * Event description: when an action button is clicked in a plugins action sheet in mobile app
 *
 * @param {mobilePluginsActionSheetClickParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - -
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} pluginName - -
 * @property {string} buttonName - button clicked
 * @property {string} plugin_id - -
 * @property {string} content_id - -
 * @return {LogObject<mobilePluginsActionSheetClickParams>} LogObject<mobilePluginsActionSheetClickParams>
 */
export function mobilePluginsActionSheetClick(params) {
    return { evid: 49, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'publishPost' event (evid: 5)
 *
 * Event description: user published his post - currently Desktop only
 *
 * @param {publishPostParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} params - more details about plugins { plugin_uniqe_id: details}
 * @property {string} container - blog/groups...
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
 * @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
 * @property {string} content_id - content_id
 * @return {LogObject<publishPostParams>} LogObject<publishPostParams>
 */
export function publishPost(params) {
    return { evid: 5, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginsPopoverClick' event (evid: 50)
 *
 * Event description: Plugins Popover Click.
 *
 * @param {pluginsPopoverClickParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} button_name - button_name
 * @property {string} container - blog/groups...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - container_id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version . of rce
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - plugin_unique_id
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} origin - toolbar/sidebar/ else
 * @property {string} category - category of change (alignment/size/settings...)
 * @property {string} settingSessionId - setting_session_id
 * @property {string} plugin_id - plugin
 * @property {string} type - toolbar type (plugin toolbar/ format toolbar)
 * @property {string} plugins_details - specification of the plugin
 * @property {string} value - value changed to (center, right...)
 * @property {string} content_id - content_id
 * @return {LogObject<pluginsPopoverClickParams>} LogObject<pluginsPopoverClickParams>
 */
export function pluginsPopoverClick(params) {
    return { evid: 50, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'pluginsPopoverTabSwitch' event (evid: 51)
 *
 * Event description: Tab switches in Plugins Popover
 *
 * @param {pluginsPopoverTabSwitchParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {string} button_name - the name of the button user clicked on
 * @property {string} container - blog/groups...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version . of rce
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} origin - toolbar/sidebar/ else
 * @property {string} category - category of change (alignment/size/settings...)
 * @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
 * @property {string} plugin_id - plugin
 * @property {string} type - toolbar type (plugin toolbar/ format toolbar)
 * @property {string} plugins_details - specification of the plugin
 * @property {string} value - value changed to (center, right...)
 * @property {string} content_id - Post ID
 * @return {LogObject<pluginsPopoverTabSwitchParams>} LogObject<pluginsPopoverTabSwitchParams>
 */
export function pluginsPopoverTabSwitch(params) {
    return { evid: 51, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'panelDisplayNavigateRce' event (evid: 52)
 *
 * Event description: user navigate inside the Display panel of RCE in the editor
 *
 * @param {panelDisplayNavigateRceParams} params - The parameters for this event
 * @property {string} subcategory - background/texts/button and links
 * @property {string} selection - selection
 * @property {string} category - category
 * @property {string} component_id - unique id of the component
 * @property {string} value - value of the field
 * @property {string} content_id - unique id of the post
 * @return {LogObject<panelDisplayNavigateRceParams>} LogObject<panelDisplayNavigateRceParams>
 */
export function panelDisplayNavigateRce(params) {
    return { evid: 52, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'tiptapFailureMonitoring' event (evid: 53)
 *
 * Event description: Monitor Tiptap failures on mobile editor
 *
 * @param {tiptapFailureMonitoringParams} params - The parameters for this event
 * @property {string} error_stack - error stack
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - rce_session_id
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} content_id - Unique id for each content
 * @property {string} engine - Tiptap / draft
 * @return {LogObject<tiptapFailureMonitoringParams>} LogObject<tiptapFailureMonitoringParams>
 */
export function tiptapFailureMonitoring(params) {
    return { evid: 53, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'clickConnectToDataRcePanelCm' event (evid: 54)
 *
 * Event description: user click on edit content inside the panel of RCE in Content Manager
 *
 * @param {clickConnectToDataRcePanelCmParams} params - The parameters for this event
 * @property {string} component_id - unique id of the component
 * @property {string} content_id - content_id
 * @return {LogObject<clickConnectToDataRcePanelCmParams>} LogObject<clickConnectToDataRcePanelCmParams>
 */
export function clickConnectToDataRcePanelCm(params) {
    return { evid: 54, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'audioPluginDetails' event (evid: 55)
 *
 * Event description: Details for audio plugin
 *
 * @param {audioPluginDetailsParams} params - The parameters for this event
 * @property {Url} url - url (applicable for embed)
 * @property {string} params - params will arrive according to the plugin
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - wix_ricos_version
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} creator - Audio file creator
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugin_id - plugin id
 * @property {string} title - Audio file title
 * @property {string} type - File / Spotify / SoundCloud
 * @property {string} content_id - Unique ID for content
 * @property {string} track_duration - Track duration
 * @return {LogObject<audioPluginDetailsParams>} LogObject<audioPluginDetailsParams>
 */
export function audioPluginDetails(params) {
    return { evid: 55, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'showMoreClick' event (evid: 56)
 *
 * Event description: show more click in livesite
 *
 * @param {showMoreClickParams} params - The parameters for this event
 * @property {string} post_id - post id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} container - blog/groups/forum etc...
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {GUID} site_member_id - site_member_id
 * @property {string} action_type - show_more / show_less
 * @property {string} content_id - content_id
 * @return {LogObject<showMoreClickParams>} LogObject<showMoreClickParams>
 */
export function showMoreClick(params) {
    return { evid: 56, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'addPluginSuccess' event (evid: 6)
 *
 * Event description: add plugin successfully
 *
 * @param {addPluginSuccessParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events etc
 * @property {string} post_id - post_id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} params - more details about the plugin
 * @property {string} container - blog/forum/groups...
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group/ forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - version of RCE
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} entry_point - side_toolbar / footer_toolbar / copy_pasted
 * @property {string} mediaOrigin - Upload/MediaCenter
 * @property {string} plugin_id - plugin_id
 * @property {string} plugins_details - specification of the plugin
 * @property {string} content_id - content_id
 * @property {string} entry_type - specification for the entry point
 * @return {LogObject<addPluginSuccessParams>} LogObject<addPluginSuccessParams>
 */
export function addPluginSuccess(params) {
    return { evid: 6, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'oaGetPostContent' event (evid: 7)
 *
 * Event description: sent when consumer requests post content from RCE in OneApp
 *
 * @param {oaGetPostContentParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} container - blog/forum etc
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - id of group / forum etc
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - RCE version
 * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
 * @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
 * @property {string} content_id - content_id
 * @return {LogObject<oaGetPostContentParams>} LogObject<oaGetPostContentParams>
 */
export function oaGetPostContent(params) {
    return { evid: 7, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'viewerAction' event (evid: 8)
 *
 * Event description: UoU did some action in the RCE viewer
 *
 * @param {viewerActionParams} params - The parameters for this event
 * @property {string} plugin_specification - bookings/stores/events
 * @property {string} action_name - image_link/expand_image etc.
 * @property {string} post_id - post_id
 * @property {string} params - more details about plugins
 * @property {string} container - groups/blog etc
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - app_def_id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} productType - Product Specification (e.g. type of vertical embed)
 * @property {string} pluginUniqueId - unique id for each plug in
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} plugin_id - []
 * @property {string} plugins_details - plugins_details
 * @property {string} value - additional information
 * @property {string} content_id - content_id
 * @return {LogObject<viewerActionParams>} LogObject<viewerActionParams>
 */
export function viewerAction(params) {
    return { evid: 8, src: 116, endpoint: 'rich-editor', params: params };
}
/**
 * A function to create a log object for the 'openEditorSuccess' event (evid: 9)
 *
 * Event description: successfully opened rce
 *
 * @param {openEditorSuccessParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {string} editor_engine - draft/tiptap
 * @property {string} container - consumer name
 * @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
 * @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
 * @property {string} container_id - consumer app def id
 * @property {string} container_platform - Livesite / BM / OneApp
 * @property {string} version - rce version
 * @property {GUID} rce_session_id - (on refresh)
 * @property {string} toolbarType - Formatting Toolbar is one of: ["sticky", "inline"]
 * @property {string} container_usage - Post / Feed / Comment
 * @property {string} content_id - external content id (based on usage)
 * @return {LogObject<openEditorSuccessParams>} LogObject<openEditorSuccessParams>
 */
export function openEditorSuccess(params) {
    return { evid: 9, src: 116, endpoint: 'rich-editor', params: params };
}
//# sourceMappingURL=index.js.map